import NavBar from "../../Navbar/Navbar";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import fetchModel from "../../../AdminAPI/ModelADM";
import fetchClient from "../../../AdminAPI/ClientList";
import { createInstanceAndDocsADM } from "../../../AdminAPI/UploadToS3ADM";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faXmark,
  faCheck,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { Modal, Spinner } from "reactstrap";
import { generateInstanceName } from "../../Utils/DateManager";
import { useNavigate } from "react-router-dom";
import { getModel } from "../../../API/ModelList";
import { createInstanceAndDocs } from "../../../API/UploadToS3";
import { Button } from "react-bootstrap";
import { getDocsKeyFromModelId } from "../../Utils/ImportUtils";
import { setEnvironmentColors } from "../../Utils/EnvironnementColor";

const DemoInvoice = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [model, setModel] = useState([]);
  const [client, setClient] = useState([]);
  const [selectedModelId, setSelectedModelId] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [Documents, setDocuments] = useState([]);
  const [Error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const role = Cookies.get("Role");
  const [colorFilter, setcolorFilter] = useState("#235073");
  const [isDragOver, setIsDragOver] = useState(false);
  const [videoCodingChecked, setVideoCodingChecked] = useState(false);
  const [customFinalCustomer, setCustomFinalCustomer] = useState("Header");
  const [overlayActive, setOverlayActive] = useState(false);


  const navigate = useNavigate();

  const baseDocJsonNone = JSON.stringify({ ManualReview: { S: "None" } });
  const errorDocJson = JSON.stringify({ ManualReview: { S: "ERROR" } });

  const idToken = Cookies.get("Token");
  const { t } = useTranslation();

  const selectedModel = model.find((mod) => mod.id === selectedModelId);
  const finalRoute =
    role === "superadmin"
      ? `/Admin`
      : `/User/${getDocsKeyFromModelId(selectedModelId)}`;

  useEffect(() => {
    if (role === "superadmin") {
      const fetchAll = async () => {
        setIsLoading(true);
        try {
          const ModelData = await fetchModel(null, idToken);
          const AllModels = ModelData.map((model) => ({
            id: model.ModelId,
            name: model.ModelName,
            component: model.ModelComponent,
            statusList: model.ModelDocumentStatus || [],
            ModelSupportedFileTypes: model.ModelSupportedFileTypes,
          }));
          setModel(AllModels);
        } catch (error) {
          console.error("Erreur lors du chargement des modèles", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchAll();
    } else {
      const fetchAll = async () => {
        setIsLoading(true);
        try {
          const ModelData = await getModel(idToken);
          const AllModels = ModelData.map((model) => ({
            id: model.ModelId,
            name: model.ModelName,
            component: model.ModelComponent,
            statusList: model.ModelDocumentStatus || [],
            ModelSupportedFileTypes: model.ModelSupportedFileTypes,
          }));
          setModel(AllModels);
          setSelectedModelId(AllModels?.[0]?.id);
        } catch (error) {
          console.error("Erreur lors du chargement du modèle", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchAll();
    }
  }, []);

  useEffect(() => {
    if (role === "superadmin") {
      const fetchClientsForModel = async () => {
        if (!selectedModelId) return;
        try {
          const ClientData = await fetchClient(idToken, selectedModelId);
          setClient(ClientData);
        } catch (error) {
          console.error("Erreur lors du chargement des clients :", error);
        }
      };
      fetchClientsForModel();
    } else {
      const userClient = Cookies.get("Client");
      setSelectedClient(userClient);
    }
  }, [selectedModelId]);

  const handleModelChange = (e) => {
    setSelectedModelId(e.target.value);
  };

  const handleClientChange = (e) => {
    setSelectedClient(e.target.value);
  };

  const getSupportedFileTypes = () => {
    if (!selectedModel) return [];
    return selectedModel.ModelSupportedFileTypes;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      const fakeEvent = { target: { files } };
      addDocuments(fakeEvent);
    }
  };

  const addDocuments = (event) => {
    const files = Array.from(event.target.files);
    const supportedFileTypes = getSupportedFileTypes();
    const validFiles = files.filter((file) =>
      supportedFileTypes.includes(file.name.split(".").pop().toLowerCase())
    );

    if (validFiles.length !== files.length) {
      setError(t("Some files are not supported."));
    }

    const newDocs = validFiles.map((file) => ({ name: file.name, file }));
    setDocuments((prevDocs) => [...prevDocs, ...newDocs]);
  };

  const removeDocument = (index) => {
    setDocuments(Documents.filter((_, i) => i !== index));
  };

  const handleCreateInstanceAndDocs = async () => {
    if (!selectedModelId || !selectedClient) {
      setError(t("Please select a model and customer before continuing."));
      return;
    }
    if (Documents.length === 0) {
      setError(t("Please add at least one document."));
      return;
    }

    if (Documents.length > 5) {
      setError(t("You can only import 5 documents at a time."));
      return;
    }
    try {
      setSuccess(false);
      setOverlayActive(true);
      setLoading(true);
      const instanceName = generateInstanceName();
      const modelId = selectedModelId;
      const token = idToken;
      const expectedDocs = Documents.length;
      const sFinalCustomer = customFinalCustomer;
      const finalDocJson = videoCodingChecked ? errorDocJson : baseDocJsonNone;
      const jsonArray = Documents.map(() => finalDocJson);
      const ClientId = selectedClient;

      const createInstanceFunc =
        role === "superadmin"
          ? createInstanceAndDocsADM
          : createInstanceAndDocs;

      await createInstanceFunc(
        instanceName,
        modelId,
        Documents.map((doc) => doc.file),
        token,
        true,
        jsonArray,
        expectedDocs,
        sFinalCustomer,
        ClientId
      );

      Cookies.set("modelId", selectedModelId);
      Cookies.set("instanceName", instanceName);
      setLoading(false);
      setSuccess(true);
      setError(null);
    } catch (error) {
      console.error(t("Error creating :"), error);
      setError(t("Error creating instance and documents."));
      setSuccess(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    setEnvironmentColors([[setcolorFilter, "colorFilter"]]);
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: "#F7F9F9", minHeight: "100vh" }}>
      <NavBar />
      
      {/* 1. BLOC TITRE (JAMAIS affecté par l'opacité) */}
      <div id="adm-doc-status-header-container">
        <div id="adm-doc-status-title-block">
          <h1
            id="adm-doc-status-title"
            style={{
              fontSize: "28px",
              fontWeight: "600",
              fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              margin: 0,
            }}
          >
            <i className="fas fa-upload" style={{ color: "black" }}></i>
            {t("Demo invoice")}
          </h1>
          <div
            id="adm-doc-status-title-line"
            style={{
              height: "4px",
              width: "150px",
              borderRadius: "2px",
              background: "linear-gradient(90deg, turquoise, green)",
            }}
          />
        </div>
        
        {/* SÉLECTEURS ADMIN (Affectés par l'opacité pour les désactiver) */}
        {role === "superadmin" && (
          <div 
            id="adm-doc-status-container"
            style={{
                opacity: overlayActive ? 0.3 : 1, // Application de l'opacité ici
                pointerEvents: overlayActive ? "none" : "auto",
                transition: "opacity 0.3s ease",
            }}
          >
            <select
              value={selectedModelId}
              onChange={handleModelChange}
              className="adm-doc-status-select"
            >
              <option value="">{t("Choose a model")}</option>
              {model.map((mod) => (
                <option key={mod.id} value={mod.id}>
                  {mod.id} - {mod.name}
                </option>
              ))}
            </select>

            {selectedModel && (
              <select
                value={selectedClient}
                onChange={handleClientChange}
                className="adm-doc-status-select"
              >
                <option value="">{t("Choose a client")}</option>
                {client.map((c) => (
                  <option key={c.ClientId} value={c.ClientId}>
                    {c.ClientId}
                  </option>
                ))}
              </select>
            )}
          </div>
        )}
      </div>
      {/* FIN BLOC 1 */}
      
      
      {(selectedModel || role === "user") && (
        <>
        
          {/* LIGNE DES FICHIERS SUPPORTÉS (JAMAIS affectée par l'opacité) */}
          <p style={{ textAlign: "left", marginLeft: "1vw" }}>
            {t("Supported files")}:{" "}
            {getSupportedFileTypes().length > 0
              ? getSupportedFileTypes().join(", ")
              : t("No supported file types defined for this model.")}
          </p>
        
          {/* 2. BLOC FORMULAIRE/DOCUMENTS (Affecté par l'opacité) */}
          <div
             style={{
                opacity: overlayActive ? 0.3 : 1,
                pointerEvents: overlayActive ? "none" : "auto",
                transition: "opacity 0.3s ease",
             }}
          >
            
            {/* Bloc "Vidéocodage ?" */}
            <div
              style={{
                width: "50vw",
                margin: "10px auto 20px auto",
                textAlign: "left",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                backgroundColor: "#f9f9f9",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ fontWeight: "bold" }}>{t("Videocodage ?")}</span>

              <label
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: "80px",
                  height: "34px",
                  cursor: "pointer",
                }}
              >
                {/* La VRAIE case à cocher (cachée) */}
                <input
                  type="checkbox"
                  checked={videoCodingChecked}
                  onChange={(e) => setVideoCodingChecked(e.target.checked)}
                  style={{ opacity: 0, width: 0, height: 0 }}
                  disabled={overlayActive}
                />

                <span
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: videoCodingChecked ? "#28a745" : "#54373a79",
                    transition: "0.4s",
                    borderRadius: "34px",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      height: "26px",
                      width: "26px",
                      left: "4px",
                      bottom: "4px",
                      backgroundColor: "white",
                      transition: "0.4s",
                      borderRadius: "50%",
                      transform: videoCodingChecked
                        ? "translateX(46px)"
                        : "translateX(0)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "14px",
                      color: videoCodingChecked ? "#28a745" : "#54373a79",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={videoCodingChecked ? faCheck : faXmark}
                    />
                  </span>
                </span>
              </label>
            </div>
            
            {/* Bloc "Format de facture" */}
            <div
              style={{
                width: "50vw",
                margin: "10px auto 20px auto",
                textAlign: "left",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                backgroundColor: "#f9f9f9",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ fontWeight: "bold" }}>{t("Format of invoice")}</span>

              <div style={{ display: "flex", gap: "15px" }}>
                <button
                disabled={overlayActive}
                  onClick={() => setCustomFinalCustomer("Lines")}
                  style={{
                    padding: "6px 40px",
                    borderRadius: "5px",
                    fontWeight: "bold",
                    fontSize: "16px",
                    cursor: "pointer",
                    transition: "0.2s",
                    backgroundColor:
                      customFinalCustomer === "Lines" ? "#009f93" : "#e9ecef", // Vert foncé / Gris
                    color: customFinalCustomer === "Lines" ? "white" : "#333",
                    border: `2px solid ${
                      customFinalCustomer === "Lines" ? "#009f93" : "#ccc"
                    }`,
                  }}
                >
                  {t("Lines")}
                </button>
                <button
                disabled={overlayActive}
                  onClick={() => setCustomFinalCustomer("Header")}
                  style={{
                    padding: "6px 40px",
                    borderRadius: "5px",
                    fontWeight: "bold",
                    fontSize: "16px",
                    cursor: "pointer",
                    transition: "0.2s",
                    // Styles Conditionnels
                    backgroundColor:
                      customFinalCustomer === "Header" ? "#009f93" : "#e9ecef", // Bleu foncé / Gris
                    color: customFinalCustomer === "Header" ? "white" : "#333",
                    border: `2px solid ${
                      customFinalCustomer === "Header" ? "#009f93" : "#ccc"
                    }`,
                  }}
                >
                  {t("Header")}
                </button>
              </div>
            </div>
            
            {/* Bloc de Documents / Drag and Drop */}
            <div
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
              onDragEnter={() => setIsDragOver(true)}
              onDragLeave={() => setIsDragOver(false)}
              className="table-responsive"
              style={{
                padding: "0", // Padding géré en interne
                borderRadius: "5px",
                overflow: "hidden",
                width: "50vw",
                margin: "auto",
                border: "1px dashed #909490ff",
                backgroundColor: "white",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease-in-out",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 15px",
                  background:  "#385b57", 
                  borderBottom:
                    Documents.length > 0 ? "1px solid #e0e0e0" : "none",
                }}
              >
                <h4
                  style={{
                    margin: 0,
                    color: "#ffffffff",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  {t("Documents")}
                  {Documents.length > 0 && (
                    <span
                      style={{
                        marginLeft: "10px",
                        fontSize: "14px",
                        color: "#ebfeffff",
                        fontWeight: "normal",
                      }}
                    >
                      ({Documents.length})
                    </span>
                  )}
                </h4>
                <button
                  disabled={overlayActive}
                  onClick={() => document.getElementById("addDoc").click()}
                  style={{
                    backgroundColor: "#009f93", // Turquoise Vert Vibrant
                    color: "white",
                    padding: "8px 15px",
                    borderRadius: "4px",
                    border: "none",
                    fontWeight: "600",
                    cursor: "pointer",
                    boxShadow: "0 2px 4px rgba(0, 200, 150, 0.3)",
                    transition: "background-color 0.2s, transform 0.1s",
                    fontSize: "14px",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#22beb1ff")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#009f93")
                  }
                >
                  <FontAwesomeIcon icon={faPlus} style={{ marginRight: "8px" }} />
                  {t("New Document")}
                </button>
              </div>

              {/* Lignes des Documents */}
              {Documents.length > 0 && (
                <div style={{ width: "100%", flexGrow: 1, overflowY: "auto" }}>
                  {Documents.map((doc, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #f0f0f0",
                        padding: "10px 15px",
                        transition: "background-color 0.2s",
                        cursor: "default",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f4faff")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "white")
                      }
                    >
                      <div
                        style={{ flexGrow: 1, color: "#34495e", fontWeight: 500 }}
                      >
                        <FontAwesomeIcon
                          icon={faCheck}
                          style={{ marginRight: "10px", color: "#004836ff" }}
                        />
                        {doc.name}
                      </div>
                      <div style={{ width: "100px", textAlign: "right" }}>
                        <button
                          style={{
                            border: "none",
                            background: "transparent",
                            color: "#e74c3c",
                            fontSize: "18px",
                            cursor: "pointer",
                            transition: "color 0.2s, transform 0.1s",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.color = "#c0392b";
                            e.currentTarget.style.transform = "scale(1.1)";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.color = "#e74c3c";
                            e.currentTarget.style.transform = "scale(1.0)";
                          }}
                          onClick={() => removeDocument(index)}
                        >
                          <FontAwesomeIcon icon={faXmark} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Placeholder (affiché en permanence) */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "40px 20px",
                  textAlign: "center",
                  color: "#7f8c8d",
                  flexGrow: 1,

                  // DOTTED BORDER UNIQUEMENT EN DRAG MODE
                  border: isDragOver ? "2px dashed #00C896" : "none",
                  margin: isDragOver ? "15px" : "0",
                  transition: "all 0.3s",
                }}
              >
                <FontAwesomeIcon
                  icon={faUpload}
                  style={{
                    fontSize: "40px",
                    marginBottom: "15px",
                    color: "#004836ff",
                  }}
                />
                <p
                  style={{
                    margin: "5px 0",
                    fontWeight: "500",
                    color: "#34495e",
                  }}
                >
                  {t("Drag and drop invoices here")}
                </p>
              </div>
              

              {/* Input file caché (essentiel) */}
              <input
                id="addDoc"
                type="file"
                multiple
                onChange={addDocuments}
                style={{ display: "none" }}
              />
            </div>
            
          </div>
          {/* FIN BLOC 2 */}
          
          
          {/* 3. BLOC ACTIONS/MESSAGES (JAMAIS affecté par l'opacité) */}
          <div
            style={{
              width: "55vw",
              maxWidth: "700px",
              margin: "30px auto 50px auto",
              textAlign: "center",
              padding: "20px 0",
            }}
          >
            {Error && (
              <div
                style={{
                  color: "#dc3545",
                  backgroundColor: "#f8d7da",
                  border: "1px solid #f5c6cb",
                  padding: "10px",
                  borderRadius: "6px",
                  marginBottom: "20px",
                  fontWeight: "500",
                  fontSize: "15px",
                }}
              >
                {Error}
              </div>
            )}

            {/* Message de Succès */}
            {success && (
              <div
                style={{
                  backgroundColor: "#d9f7e9", // Fond vert très clair
                  color: "#006D66", // Texte turquoise foncé
                  border: "1px solid #b7e0d3",
                  padding: "15px",
                  borderRadius: "8px",
                  marginBottom: "20px",
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                {t("Instance and docs successfully created")}
              </div>
            )}

            {/* CONTENEUR DES BOUTONS */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              {/* BOUTON "CRÉER INSTANCE" */}
              {!success && (
                <button
                  onClick={handleCreateInstanceAndDocs}
                  style={{
                    backgroundColor: "#009f93",
                    color: "white",
                    padding: "12px 30px",
                    borderRadius: "6px",
                    border: "none",
                    fontWeight: "700",
                    cursor: "pointer",
                    boxShadow: "0 4px 8px rgba(0, 200, 150, 0.4)",
                    transition: "background-color 0.2s",
                    fontSize: "16px",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#22beb1ff")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#009f93")
                  }
                >
                  {t("Create instance")}
                </button>
              )}

              {/* BOUTONS DE NAVIGATION */}
              {success && (
                <>
                  {/* Bouton Primaire de Succès : Retour à l'Instance */}
                  <button
                    onClick={() => navigate(finalRoute)}
                    style={{
                      backgroundColor: "#009f93", // Turquoise foncé pour l'action réussie
                      color: "white",
                      padding: "12px 30px",
                      borderRadius: "6px",
                      border: "none",
                      fontWeight: "700",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                      fontSize: "16px",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#006D66")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#009f93")
                    }
                  >
                    {role === "superadmin" ? t("Return") : t("Return instance")}
                  </button>

                  {/* Bouton Secondaire : Nouvelle Instance */}
                  <button
                    onClick={() => window.location.reload()}
                    style={{
                      backgroundColor: "#95a5a6", // Gris neutre pour l'action secondaire
                      color: "white",
                      padding: "12px 30px",
                      borderRadius: "6px",
                      border: "none",
                      fontWeight: "700",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                      fontSize: "16px",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#7f8c8d")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#95a5a6")
                    }
                  >
                    {t("New instance")}
                  </button>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {loading && (
        <Modal isOpen={true} centered>
          <div className="modal-body text-center">
            <Spinner color="primary" />
            <h4>{t("Processing in progress")}</h4>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default DemoInvoice;